let lastScrollPos = 0;
var el = document.querySelector('.mobile-sticky-form');
let productForm = document.querySelector('.product-container__main');
let stickyForm = el.querySelector('form');
var idElement = stickyForm.querySelector('[name="id"]');
var quantity = 1;
var properties = {};
var addToCartBTN = document.querySelector('.purchase-btn');
var stickyBTN = stickyForm.querySelector('button');
var bagIconCount = document.querySelector('.cart-icon .item-count');

stickyBTN.addEventListener('click', async (e) => {
	e.preventDefault();
	let id = parseInt(idElement.value);
	let productResult = await addItemToCart(id, quantity, properties);
	document.dispatchEvent(new Event('addedToCart'));
});

const addItemToCart = async (id, quantity, properties) => {
	// add item to the cart without refreshing the  page
	let formData = {
		items: [
			{
				id: id,
				quantity: quantity,
				properties: properties,
			},
		],
	};
	var addItem = await fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			return data;
		});
};

let stickFormClose = el.querySelector('[data-mobile-sticky-form-close]');
stickFormClose.addEventListener('click', async (e) => {
	e.preventDefault();
	el.style.display = 'none';
});

const processScroll = () => {
	var scrollY = window.scrollY || window.pageYOffset;

	let documentHeight = document.body.offsetHeight - window.innerHeight;
	let footerHeight = document.querySelector(
		'#shopify-section-footer'
	).offsetHeight;

	// Code for the chat widget on mobile so that it sits above the mobile sticky form
	var bannerHeight = document.querySelector(
		'.mobile-sticky-form'
	).offsetHeight;
	var widget = document.querySelector('#gorgias-chat-container > div');

	if (scrollY > addToCartBTN.offsetTop + addToCartBTN.offsetHeight) {
		el.classList.add('visible');
		widget.style.cssText += 'bottom:' + bannerHeight + 'px';
	} else {
		el.classList.remove('visible');
		widget.style.cssText = '';
	}
};

document.onreadystatechange = function () {
	if (document.readyState === 'complete') {
		processScroll();
	}
};
['resize', 'scroll'].forEach(function (e) {
	window.addEventListener(e, function () {
		processScroll();
	});
});
